// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1x-2";
export var placeholderIcon = "_1x-3";
export var thumbnailCanvas = "_1x-1";
export var thumbnailWrapper = "_1x-0";